import type { ReactNode } from 'react';
import { usePhone } from '@/lib/responsive';
import { ResponsiveOverlay } from './responsive-overlay';

/** Keep desktop menus intact; use the same controlled picker inside a phone sheet. */
export function ResponsivePicker({
  label,
  onClose,
  children,
  kind = 'picker',
}: {
  label: string;
  onClose: () => void;
  children: ReactNode;
  kind?: 'picker' | 'confirmation';
}) {
  const phone = usePhone();
  if (!phone) return <>{children}</>;
  return (
    <ResponsiveOverlay label={label} kind={kind} className="control-picker" onClose={onClose}>
      <div className="drawer-hd">
        <h2>{label}</h2>
        <button className="btn" onClick={onClose}>
          {kind === 'confirmation' ? 'Cancel' : 'Done'}
        </button>
      </div>
      {children}
    </ResponsiveOverlay>
  );
}
